import { useMedia } from '#hooks/use-media.js';
import { makeTailwindPalette } from './helpers.jsx';

export default function useDetail(props) {
    const { themes, selectedProfile, editProfile, editProfileColors, errors, setErrors, setUnsavedChanges } = props;
    // theme
    const selectedTheme =
        themes?.find((el) => el.id === selectedProfile?.styles?.themeId) || themes?.find((el) => el.isDefault);
    const defaultStyles = selectedTheme?.defaultStyles && JSON.parse(selectedTheme?.defaultStyles);

    // supported languages
    let supportedLanguages = defaultStyles?.supportedLanguages || [];

    // primary and neutral colors
    const primaryColors = selectedProfile?.styles?.colors?.primary || defaultStyles?.colors?.primary || {};
    const neutralColors = selectedProfile?.styles?.colors?.neutral || defaultStyles?.colors?.neutral || {};

    const mediaLogo = useMedia({
        initialData: selectedProfile?.companyLogo,
        onAdd: (media) => {
            editProfile(selectedProfile.id, 'companyLogo', media);
        },
        onUpload: (media) => {
            editProfile(selectedProfile.id, 'companyLogo', media);
        },
        onDelete: () => {
            editProfile(selectedProfile.id, 'companyLogo', null);
        }
    });
    const mediaCover = useMedia({
        initialData: selectedProfile?.defaultCover,
        onAdd: (media) => {
            editProfile(selectedProfile.id, 'defaultCover', media);
        },
        onUpload: (media) => {
            editProfile(selectedProfile.id, 'defaultCover', media);
        },
        onDelete: () => {
            editProfile(selectedProfile.id, 'defaultCover', null);
        }
    });
    const mediaIntro = useMedia({
        initialData: selectedProfile?.defaultIntro,
        onAdd: (media) => {
            editProfile(selectedProfile.id, 'defaultIntro', media);
        },
        onUpload: (media) => {
            editProfile(selectedProfile.id, 'defaultIntro', media);
        },
        onDelete: () => {
            editProfile(selectedProfile.id, 'defaultIntro', null);
        }
    });
    const mediaJingle = useMedia({
        initialData: selectedProfile?.defaultJingle,
        onAdd: (media) => {
            editProfile(selectedProfile.id, 'defaultJingle', media);
        },
        onUpload: (media) => {
            editProfile(selectedProfile.id, 'defaultJingle', media);
        },
        onDelete: () => {
            editProfile(selectedProfile.id, 'defaultJingle', null);
        }
    });

    const logo = mediaLogo.data ? mediaLogo.data?.meta : selectedProfile?.companyLogo;
    const defaultCover = mediaCover.data ? mediaCover.data?.meta : selectedProfile?.defaultCover;
    const defaultIntro = mediaIntro.data ? mediaIntro.data?.meta : selectedProfile?.defaultIntro;
    const defaultJingle = mediaJingle.data ? mediaJingle.data?.meta : selectedProfile?.defaultJingle;
    const { companyContent, customerContent } = selectedProfile ?? {};

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUnsavedChanges(true);
        if (errors[name] && value) {
            const updatedErrors = structuredClone(errors);
            updatedErrors[name] = false;
            setErrors(updatedErrors);
        }
        if (name === 'primaryPalette' || name === 'neutralPalette') {
            const type = name === 'primaryPalette' ? 'primary' : 'neutral';
            const palette = value === 'custom' ? makeTailwindPalette('neutral') : makeTailwindPalette(value);
            editProfileColors(selectedProfile.id, type, palette);
        }
        if (e.target.type === 'checkbox') {
            return editProfile(selectedProfile.id, name, e.target.checked);
        }
        editProfile(selectedProfile.id, name, value);
    };

    const handleChangeDropdown = (name, value) => {
        setUnsavedChanges(true);
        if (errors[name] && value) {
            const updatedErrors = structuredClone(errors);
            updatedErrors[name] = false;
            setErrors(updatedErrors);
        }
        switch (name) {
            case 'themeId':
                const theme = themes.find((el) => el.name === value);
                editProfile(selectedProfile.id, 'themeId', theme.id, true);
                const themeLanguages = JSON.parse(theme.defaultStyles)?.supportedLanguages;
                const language = themeLanguages.find((el) => el.id === 'en')?.id || themeLanguages[0].id;
                editProfile(selectedProfile.id, 'language', language);
                break;
            case 'language':
                editProfile(selectedProfile.id, 'language', value?.id);
                break;
            default:
                const type = name === 'primaryPalette' ? 'primary' : 'neutral';
                const palette = value === 'custom' ? makeTailwindPalette('neutral') : makeTailwindPalette(value);
                editProfileColors(selectedProfile.id, type, palette);
                editProfile(selectedProfile.id, name, value);
        }
    };

    return {
        handleChangeDropdown,
        handleChange,
        logo,
        defaultCover,
        defaultIntro,
        defaultJingle,
        customerContent,
        companyContent,
        supportedLanguages,
        primaryColors,
        neutralColors,
        mediaLogo,
        mediaCover,
        mediaIntro,
        mediaJingle,
        selectedTheme
    };
}
